import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const state={
    account:""
}
const mutations={
    add(state,accountText){
        state.account = accountText;
    }
}
const actions = {
    addAccount(state,data){
        return new Promise(resolve => {
            state.commit('add',data)
            resolve()
        })
    }
}
export default new Vuex.Store({
    state,mutations,actions
})


// WEBPACK FOOTER //
// ./src/store/index.js